import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  'pk_test_51JwuIICTUsxZxyrkuNLSly0hkUUq8pmJYxm0MThYGonAhyxL4OLyjZZ58daCea8oIVwlqEBP7lykr2whpYZgnQPW009yog3SpO',
);

export enum StripeBtnTypes {
  Cars = 'CARS',
  Hotel = 'HOTEL'
}

export enum StripeChargeStatus {
  PENDING_EXPRESS = 'PendingExpress',
}
